import { render, staticRenderFns } from "./ProfileStep.vue?vue&type=template&id=1451fd2c&scoped=true"
import script from "./ProfileStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProfileStep.vue?vue&type=style&index=0&id=1451fd2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1451fd2c",
  null
  
)

export default component.exports